import { render, staticRenderFns } from "./FeedbackQuestionTable.vue?vue&type=template&id=861260f0&scoped=true&"
import script from "./FeedbackQuestionTable.vue?vue&type=script&lang=js&"
export * from "./FeedbackQuestionTable.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackQuestionTable.vue?vue&type=style&index=0&id=861260f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861260f0",
  null
  
)

export default component.exports